<template>
  <div>
    <v-row justify="center">
      <v-dialog v-model="dialog" persistent max-width="600px">
        <v-card>
          <v-toolbar flat dark color="primary">
            <v-spacer></v-spacer>
            <v-btn icon dark @click="closeDialog">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar>
          <v-card-title>
            <span class="headline">欢迎试用<b>蜜蜂代理</b></span>
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text>
            <v-container class="text-center">
              <v-btn
                color="primary darken-1"
                :disabled="secretBtn"
                @click="userTestSecretService"
                >试用短效代理</v-btn
              >
              <!--              <v-btn-->
              <!--                color="success"-->
              <!--                class="ml-5"-->
              <!--                :disabled="tunnelBtn"-->
              <!--                @click="userTestTunnelService"-->
              <!--                >试用隧道代理</v-btn-->
              <!--              >-->

              <b-alert
                :show="true"
                variant="warning"
                class="font-size-lg mt-5 text-left"
              >
                <p>使用说明：</p>
                <p>1. 短效代理：用户请求API接口，返回代理IP列表</p>
                <!--                <p>2. 隧道代理：提供统一的入口，动态转发请求 隧道代理提供 5 个并发，3 小时的测试时间</p>-->
                <p>
                  2. 试用套餐说明：短效 API 代理提供 200 个 IP、1天有效时间；
                </p>
              </b-alert>
            </v-container>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-row>
  </div>
</template>

<script>
import { testService } from "@/api/service";
import { mapGetters } from "vuex";
export default {
  name: "TestService",
  computed: {
    ...mapGetters(["currentUserBalance", "currentBuyMessage", "currentUser"]),
  },
  props: {
    dialog: {
      type: Boolean,
      required: true,
      default: false,
    },
  },
  data() {
    return {
      secretBtn: false,
      tunnelBtn: false,
      testCode: {
        secret: 0x01,
        tunnel: 0x02,
      },
    };
  },
  created() {
    if (
      (parseInt(this.currentUser["is_test"], 16) & this.testCode.secret) ===
      this.testCode.secret
    ) {
      this.secretBtn = true;
    }
    if (
      (parseInt(this.currentUser["is_test"], 16) & this.testCode.tunnel) ===
      this.testCode.tunnel
    ) {
      this.tunnelBtn = true;
    }
  },
  methods: {
    closeDialog() {
      this.$emit("update:dialog", false);
    },
    userTestSecretService() {
      testService({ code: "secret" }).then((res) => {
        this.$bvToast.toast(res.message, {
          title: "",
          variant: "success",
          toaster: "b-toaster-top-center",
        });
        this.secretBtn = true;
        this.$router.push({ name: "secret-order" });
      });
    },
    userTestTunnelService() {
      testService({ code: "tunnel" }).then((res) => {
        this.$bvToast.toast(res.message, {
          title: "",
          variant: "success",
          toaster: "b-toaster-top-center",
        });
        this.tunnelBtn = true;
        this.$router.push({ name: "tunnel-order" });
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.product-sale {
  position: absolute;
  top: -8px;
  right: 0;
  background-color: orange;
  color: #fff;
  font-size: 10px;
  height: 16px;
  padding: 1px 3px;
}
</style>
